import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Icon } from '@blueprintjs/core';
import moment from 'moment';
import { withRouter } from 'react-router-dom';
import { getAvailablePages, getPageLabel } from '../../services/pageNavigation';

const base = 'secondary-header';

@inject('UserStore')
@observer
class AttendanceScanHeader extends Component {
    state = {
        currentTime: null,
        pages: []
    };

        componentDidMount() {
        const {
            UserStore: { position },
        } = this.props;
        this.currentTime();
        const pages = getAvailablePages(position);

        this.setState({pages: pages})
    }

    currentTime = () => {
        const currentTime = moment().format('LTS');
        this.setState({ currentTime });
        setTimeout(this.currentTime, 1000);
    };

    handleSetPage = (page) => {
        const {
            history,
            UserStore: { setPage },
        } = this.props;

        setPage(page);
        history.push(`/${page}`);
    };

    render() {
        const { currentTime, pages } = this.state;
        const {
            UserStore: {
                currentPage,
                isCurrentPageFullScreen
            },
            goFullscreen
        } = this.props;

        return (
            <div className={`${base}__wrapper bg--white`}>
                <div className={`${base} display--flex  pll prl ptm pbm`}>
                    <div
                        className={`${base}__left display--flex justify--space-between flex-align-items-center`}
                    >
                        <p className="fs--medium-medium-large m0 mlm">
                            {currentTime}
                        </p>
                    </div>
                    <div className={`${base}__right display--flex justify--space-between flex-align-items-center`}>
                    <div>
                        <button
                            className={`btn btn-borderless mls`}
                            onClick={() => goFullscreen()}
                        >
                            <Icon icon="fullscreen" iconSize={24} />
                        </button>
                    </div>
                    {isCurrentPageFullScreen && (
                        <div className={`${base}__dropdown `}>
                            {getPageLabel(currentPage)}
                            <svg fill="#fff" className="iconmoon-icon">
                                <use xlinkHref={`#icon-caret-down`} />
                            </svg>
                            <div className={`dropdown-content pages`}>
                                {pages
                                    .filter((page) => page !== currentPage)
                                    .map((page, i) => (
                                        <a
                                            key={i}
                                            className="cursor-pointer"
                                            onClick={() =>
                                                this.handleSetPage(page)
                                            }
                                        >
                                            {getPageLabel(page)}
                                        </a>
                                    ))}
                            </div>
                        </div>
                    )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AttendanceScanHeader);
